import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCta } from './CtaButton';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-94" data-mp="1gcxsapvh5c2f">
      <div className="mx-auto max-w-3xl" data-id="element-95" data-mp="2e0fybsxr402q">
        <h2 id="faq-title" className="text-center text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-96" data-mp="2dzeo1qok7hm2">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="mt-10 space-y-3" data-id="element-97" data-mp="241qqkszkjw07">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-cream" data-id="element-98" data-mp="1z2njz43xxhq4" data-mpi={i}>
                <h3 data-id="element-99" data-mp="snmoezitv1k2">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 rounded-2xl px-5 py-5 text-left text-[17px] font-extrabold text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal" data-id="element-100" data-mp="snwe0lzyn6p8">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-101" data-mp="ki1xplvw0cev" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-102" data-mp="3syoeqjyl3h5m">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-103" data-mp="3swtpitga52vq">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-104" data-mp="1uinv9h6mn617">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <p className="mt-6 text-center text-sm text-muted" data-id="element-105" data-mp="1fsgjfkb4kl9h">Please review the purchase terms before completing your order.</p>
        <SectionCta label="I’m ready — get instant access" data-id="element-106" data-mp="2dee0dd9uwijb" />
      </div>
    </section>;
}